import { PWA_TO_NATIVE_AUTH } from "core-lib/constants/nativeBridge";
import { getMethod, postMethod } from "core-lib/utils/apiV2";
import { passMessageToNative } from "core-lib/utils/nativeBridge";
import { getDefaultHeaders } from "core-lib/utils/network";
import { apiConfig } from "core-lib/config/config";
import { isDataValid } from "core-lib/utils/helpers";
import { PWA_URL } from "core-lib/data/common";
import { SessionStorage } from "core-lib/constants/storage";

export type ResponseType = {
  accessToken: string;
  refreshToken: string;
  profile: any;
  isNewUser: boolean;
  userLocations?: any;
};

function serialize(data): ResponseType {
  return {
    accessToken: data.token,
    refreshToken: data.refresh_token,
    profile: data.user,
    userLocations: data?.user_locations ?? null,
    isNewUser: !!data?.is_new_user,
  };
}

export type BodyType = {
  roleId?: string | number;
  otpLessToken?: string;
  state?: string;
  otp?: string | number;
  phoneNumber?: string | number;
  partnerSource?: string;
  verificationType?: string;
  fingerprintRequestId?: string;
  fingerprintVisitorId?: string;
  fingerprintPskId?: string;
  deepLinkData?: any;
};

export const verifyOTP = async (
  reqBody: BodyType
): Promise<{ response?: ResponseType; error?: any }> => {
  const headers: any = getDefaultHeaders({
    browser: true,
    os: true,
    packageName: true,
    appName: true,
  });

  let url = `${apiConfig("user")}/v4/user/clientOTPVerification/`;
  if (isDataValid(reqBody.roleId)) {
    url = `${apiConfig("user")}/user/admin/login/`;
  }
  if (reqBody.otpLessToken) {
    url = `${apiConfig("user")}/v1/user/partner/otp-less/`;
  }
  const { response: ipRes }: any = await getMethod({
    endPoint: `${PWA_URL}/api/v1/ip`,
  });
  if (ipRes?.success && ipRes?.data) headers.ip = ipRes.data;

  let body: any = {
    otp: reqBody.otp,
    state: reqBody.state,
    phone_number: reqBody.phoneNumber,
  };
  if (reqBody.fingerprintRequestId && reqBody.fingerprintVisitorId) {
    body.extra_info = {
      fp_request_id: reqBody.fingerprintRequestId,
      fp_visitor_id: reqBody.fingerprintVisitorId,
    };
  }
  if (reqBody.verificationType)
    body.verification_type = reqBody.verificationType;
  if (reqBody.partnerSource) body.partner_source = reqBody.partnerSource;
  if (reqBody.roleId) body.role_id = reqBody.roleId;
  if (reqBody.otpLessToken) {
    body = {
      otp_less_token: reqBody.otpLessToken,
    };
  }
  if (reqBody.deepLinkData) {
    body.user_utm_data = reqBody.deepLinkData;
  } else {
    const utmSource = sessionStorage.getItem(SessionStorage.utmSource);
    const utmCampaign = sessionStorage.getItem(SessionStorage.utmCampaign);
    const utmContent = sessionStorage.getItem(SessionStorage.utmContent);
    const utmTerm = sessionStorage.getItem(SessionStorage.utmTerm);
    const utmData: any = {};
    if (utmSource) {
      utmData.utm_source = utmSource;
    }
    if (utmCampaign) {
      utmData.utm_campaign = utmCampaign;
    }
    if (utmTerm) {
      utmData.utm_term = utmTerm;
    }
    if (utmContent) {
      utmData.utm_content = utmContent;
    }
    body.user_utm_data = utmData;
  }

  const { response, error }: any = await postMethod({
    endPoint: url,
    body,
    headers,
  });
  if (response) {
    // pass message to native to set auth there as well
    passMessageToNative(PWA_TO_NATIVE_AUTH, null, response);

    if (isDataValid(reqBody.roleId)) {
      return { response: serialize(response) };
    }

    const resF = serialize(response?.data);

    return { response: resF };
  }
  if (error) {
    return { error };
  }
};
